import Case from './case';

export default Case;